export const variants = {
  light: {
    hoverColor: 'hero.spinach',
    checked: {
      background: 'secondary.egg',
      border: 'border.dark',
      text: 'text.primary',
      iconBackground: 'border.dark',
    },
    unchecked: {
      background: 'background.base',
      border: 'border.dark',
      text: 'text.primary',
      iconBackground: 'border.dark',
    },
  },
  dark: {
    hoverColor: 'border.dark',
    checked: {
      background: 'background.dark',
      border: 'border.dark',
      text: 'text.lightest',
      iconBackground: 'background.lightest',
    },
    unchecked: {
      background: 'background.base',
      border: 'border.dark',
      text: 'text.primary',
      iconBackground: 'border.dark',
    },
  },
};
